/** Fachrolle und Entwurfseigentum sind unabhängig von Schreibrechten. */
export const drawerModes = {
  edit: "edit",
  view: "view",
  lookup: "lookup",
  retained: "retained",
  action: "action",
  panel: "panel",
  preview: "preview",
} as const;

export type DrawerMode = typeof drawerModes[keyof typeof drawerModes];

export function drawerActions(mode: DrawerMode, readOnly: boolean, hideSubmit: boolean) {
  const hasSubmit = !readOnly && !hideSubmit && mode !== drawerModes.view && mode !== drawerModes.lookup && mode !== drawerModes.retained;
  return {
    submit: hasSubmit,
    cancel: !readOnly && (mode === drawerModes.edit || mode === drawerModes.action || mode === drawerModes.preview),
  };
}
